/* eslint-disable no-use-before-define */
import { createSlice, createAsyncThunk, createEntityAdapter, createSelector } from "@reduxjs/toolkit";
import { loadStudents } from "@app/routes/users/api";
import { sortByFieldAlphabetically } from "@amplio-common/funcs/commonFunctionalities";

const STUDENTS_STATE_ROOT_SELECTOR = state => state.studentsV2;
const CREATE_STUDENT_SELECTOR = (s) => createSelector(STUDENTS_STATE_ROOT_SELECTOR, s);
const simpleFieldSelector = (stateField) => CREATE_STUDENT_SELECTOR(t => t[stateField]);
const sortFunc = sortByFieldAlphabetically("name");

const studentsAdapter = createEntityAdapter({
  sortComparer: sortFunc,
});

const initialState = {
  isLoading: false,
  isError: false,
  ...studentsAdapter.getInitialState(),
};

export const fetchDirectStudents = createAsyncThunk(
  "students/fetchDirectStudents",
  async (payload, thunkAPI) => {
    const { response } = await loadStudents(false);
    thunkAPI.dispatch(setStudents(response));
    return response;
  },
);

export const studentSlice = createSlice({
  name: "students",
  initialState,
  reducers: {
    setStudents: studentsAdapter.setAll,
  },
  extraReducers: {
    [fetchDirectStudents.pending]: (state) => { state.isLoading = true; state.isError = false; },
    [fetchDirectStudents.fulfilled]: (state) => { state.isLoading = false; },
    [fetchDirectStudents.rejected]: (state) => { state.isLoading = false; state.isError = true; },
  },
});
export default studentSlice.reducer;

// Actions

export const {
  setStudents,
} = studentSlice.actions;


// Selectors

export const selectIsLoadingStudents = simpleFieldSelector("isLoading");
export const selectActiveStudents = CREATE_STUDENT_SELECTOR(s => Object.values(s.entities).filter(st => st.is_active === 1).sort(sortFunc));

const studentsAdapterSelectors = studentsAdapter.getSelectors(STUDENTS_STATE_ROOT_SELECTOR);
export const { selectAll: selectAllStudents, selectIds: selectStudentIds, selectById: selectStudentById } = studentsAdapterSelectors;
